export default __webpack_public_path__ + "static/media/ezugi_dragon tiger.eb2c93d5.png";